;(function () {
  'use strict'

  angular
    .module('contrast.library.policy')
    .controller('LibraryPolicyCtrl', LibraryPolicyCtrl)

  function LibraryPolicyCtrl(
    $translate,
    $scope,
    $timeout,
    LibraryPolicyService
  ) {
    'ngInject'

    var ALL_OPTION = 'All libraries'
    var DEFAULT_OBJECT = {
      library_name: ALL_OPTION,
      language: undefined,
      sha1: undefined
    }

    var transGlobal = {
      placeholder_versions: $translate.instant('placeholder_versions')
    }

    angular.extend($scope, {
      isFailLibrariesOptionDisabled: isFailLibrariesOptionDisabled,
      save: save,
      validateRestrictions: validateRestrictions,
      addRequirement: addRequirement,
      toggleRequirements: toggleRequirements,
      onLibUpdated: onLibUpdated,
      onLibDeleted: onLibDeleted,
      deleteRequirement: deleteRequirement,
      onUpdate: onUpdate
    })

    function _setDefaults() {
      angular.extend($scope, {
        model: {
          failLibraries: false,
          restricted_libraries: [],
          restricted_licenses: [],
          available_licenses: [],
          libraries_versions_requirements: [],
          libraries_versions_requirements_enabled: false
        },
        loading: false,
        allow_override: false,
        oss_enabled: false,
        duplicateAll: false,
        duplicateLibs: false,
        placeholder_versions: transGlobal.placeholder_versions,
        libraries: [],
        // react component props
        restrictedLibraries: {
          items: [],
          values: {},
          onChange: function (items) {
            $scope.restrictedLibraries.values = items
          }
        }
      })
    }

    function isFailLibrariesOptionDisabled() {
      return (
        !$scope.model.libraries_versions_requirements_enabled &&
        !$scope.model.restrict_libraries &&
        !$scope.model.restricted_licenses.length > 0
      )
    }

    function onUpdate(restrictedLicenses) {
      $scope.restricted_licenses_enabled = restrictedLicenses.selected
      $scope.model.restricted_licenses = restrictedLicenses.values
    }

    function init() {
      _setDefaults()

      LibraryPolicyService.getInitData().then(function (response) {
        $scope.oss_enabled = response.libraryPolicy.oss_enabled
        $scope.allow_override = response.isOverrideEnabled
        $scope.model.failLibraries = response.libraryPolicy.fail_libraries
        $scope.model.restrict_libraries =
          response.libraryPolicy.restrict_libraries
        // react component prop
        $scope.restrictedLibraries.values =
          response.libraryPolicy.restricted_libraries.map(normalizeLibrary)
        $scope.model.restricted_licenses =
          response.libraryPolicy.restricted_licenses
        $scope.model.libraries_versions_requirements_enabled =
          response.libraryPolicy.libraries_versions_requirements_enabled
        $scope.model.libraries_versions_requirements = []
        $scope.model.available_licenses =
          response.orgLicenses.available_licenses
        if (
          !angular.isUndefined(
            response.libraryPolicy.libraries_versions_requirements_all
          )
        ) {
          $scope.model.libraries_versions_requirements.push({
            libs: [DEFAULT_OBJECT],
            version: response.libraryPolicy.libraries_versions_requirements_all
          })
        }

        $scope.backup = {
          libraries_versions_requirements:
            response.libraryPolicy.libraries_versions_requirements
        }

        var i, req
        for (
          i = 0;
          i < response.libraryPolicy.libraries_versions_requirements.length;
          i++
        ) {
          req = response.libraryPolicy.libraries_versions_requirements[i]
          $scope.model.libraries_versions_requirements.push({
            libs: req.library_versions_requirements,
            version: req.versions_behind
          })
        }

        $scope.libraries = response.orgLibraries

        // react component prop
        $scope.restrictedLibraries.items = normalizeLibraries(
          response.orgLibraries.map(normalizeLibrary)
        )
      })
    }

    function save() {
      $scope.loading = true

      var librariesVersionsRequirementsAll = undefined
      var libraryVersionsRequirements = []
      var libraryRestrictions = []
      var i, j, req, lib

      if ($scope.model.libraries_versions_requirements_enabled) {
        for (
          i = 0;
          i < $scope.model.libraries_versions_requirements.length;
          i++
        ) {
          req = $scope.model.libraries_versions_requirements[i]
          for (j = 0; j < req.libs.length; j++) {
            lib = req.libs[j]
            if (lib.library_name === ALL_OPTION) {
              librariesVersionsRequirementsAll = req.version
            } else {
              libraryVersionsRequirements.push({
                sha1: lib.sha1,
                library_name: lib.library_name,
                language: lib.language,
                versions_behind: req.version
              })
            }
          }
        }
      }

      for (i = 0; i < $scope.restrictedLibraries.values.length; i++) {
        lib = $scope.restrictedLibraries.values[i]
        libraryRestrictions.push({
          sha1: lib.sha1,
          language: lib.language,
          library_name: lib.library_name
        })
      }

      var form = {
        fail_libraries: $scope.model.failLibraries,
        restrict_libraries: $scope.model.restrict_libraries,
        restricted_libraries: libraryRestrictions,
        libraries_versions_requirements:
          $scope.model.libraries_versions_requirements_enabled,
        libraries_versions_requirements_all: librariesVersionsRequirementsAll,
        library_versions_requirements: libraryVersionsRequirements,
        restricted_licenses: $scope.restricted_licenses_enabled
          ? $scope.model.restricted_licenses
          : []
      }

      LibraryPolicyService.update(form)
        .then(function () {
          $timeout(function () {
            $scope.loading = false
          }, 500)
          init()
        })
        .catch(function () {
          $scope.loading = false
        })
    }

    function validateRestrictions() {
      if ($scope.model.restrict_libraries) {
        if ($scope.restrictedLibraries.values.length == 0) {
          return true
        }
      }

      if ($scope.model.libraries_versions_requirements_enabled) {
        if ($scope.duplicateAll || $scope.duplicateLibs) {
          return true
        }
        var i, requirement
        for (
          i = 0;
          i < $scope.model.libraries_versions_requirements.length;
          i++
        ) {
          requirement = $scope.model.libraries_versions_requirements[i]
          if (angular.isUndefined(requirement.version)) {
            return true
          }
        }
      }

      return false
    }

    function addRequirement() {
      $scope.model.libraries_versions_requirements.push({
        libs: [DEFAULT_OBJECT],
        version: undefined
      })
      _validateLibs()
    }

    function toggleRequirements() {
      if (
        $scope.model.libraries_versions_requirements_enabled &&
        $scope.model.libraries_versions_requirements.length === 0
      ) {
        addRequirement()
      }
    }

    function onLibUpdated(item, model, req) {
      var index = _.findIndex(req.libs, function (value) {
        return value.library_name == ALL_OPTION
      })

      if (index != -1) {
        req.libs = req.libs
          .slice(0, index)
          .concat(req.libs.slice(index + 1, req.libs.length))
      }
      _validateLibs()
    }

    function onLibDeleted(item, model, req) {
      if (req.libs.length == 0) {
        req.libs.push({
          library_name: ALL_OPTION,
          language: undefined,
          sha1: undefined
        })
      }
      _validateLibs()
    }

    function deleteRequirement(req) {
      var idx = $scope.model.libraries_versions_requirements.indexOf(req)
      if (idx > -1) {
        $scope.model.libraries_versions_requirements.splice(idx, 1)
      }
      _validateLibs()
    }

    function _validateLibs() {
      var isAllUsed = false
      var libsUsed = []
      $scope.duplicateLibs = false
      $scope.duplicateAll = false
      var i, j, requirement
      for (
        i = 0;
        i < $scope.model.libraries_versions_requirements.length;
        i++
      ) {
        requirement = $scope.model.libraries_versions_requirements[i]
        if (requirement.libs.length == 1) {
          if (angular.isUndefined(requirement.libs[0].sha1)) {
            if (isAllUsed) {
              $scope.duplicateAll = true
            }
            isAllUsed = true
          }
        }
        for (j = 0; j < requirement.libs.length; j++) {
          if (!angular.isUndefined(requirement.libs[j].sha1)) {
            if (
              _.includes(
                libsUsed,
                requirement.libs[j].sha1 + requirement.libs[j].language
              )
            ) {
              $scope.duplicateLibs = true
            }
            libsUsed.push(
              requirement.libs[j].sha1 + requirement.libs[j].language
            )
          }
        }
      }
    }

    function normalizeLibrary(library) {
      return {
        library_name: library.library_name,
        sha1: library.sha1,
        language: library.language,
        group: undefined
      }
    }

    function normalizeLibraries(libraries) {
      return [
        {
          name: undefined,
          items: libraries
        }
      ]
    }

    init()
  }
})()
